module.exports = __webpack_public_path__ + "img/pin-battery@3x.5b8f0e7f.png";